/* eslint-disable camelcase */
import { useCallback } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const MentionItem = ({
  active,
  htmlId,
  onClick,
  search,
  mention,
  char,
  itemRenderer,
}) => {
  const handleClick = useCallback(
    () => onClick({ mention, search, char }),
    [onClick, mention, search, char],
  );

  return (
    <Wrapper
      as="li"
      role="option"
      aria-selected={active}
      id={htmlId}
      $isActive={active}
      onClick={handleClick}
    >
      {itemRenderer(mention, search)}
    </Wrapper>
  );
};

MentionItem.defaultProps = {
  itemRenderer: ({ name, photo_url } = {}) => (
    <Box alignItems="center" css="color: inherit">
      {photo_url && (
        <Image
          alt={`${name} profile picture`}
          as="img"
          src={photo_url}
          aria-hidden="true"
        />
      )}
      {name}
    </Box>
  ),
};

export default MentionItem;

const Wrapper = styled(Box).attrs(({ $isActive, theme }) => ({
  bg: $isActive && 'primary',
  color: $isActive ? 'white' : theme.input.color,
  py: 2,
  px: 4,
}))`
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

const Image = styled.img`
  margin-right: ${(props) => props.theme.space[2]}px;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`;
